var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"doubles-sub-tab"},[(!_vm.tableData.length)?_c('Alert',{attrs:{"text":_vm.alertText}}):_c('SubpanelTable',{attrs:{"module":"HRPAC_CANDIDATES_DUPLICATES","tableColumns":_vm.tableColumns,"tableData":_vm.tableData,"showActionColumn":_vm.isFoundDuplicatesTable,"height":_vm.tableHeight}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }